import request from "@/utils/request.js";
/**
 * 获取用户是否加入机构
 * @param params
 * @returns {AxiosPromise}
 */
export function invitationUser(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/invitationUser",
    method: "post",
    data: params,
    showLoading: false
  });
}

/**
 * 获取首页
 * @param params
 * @returns {AxiosPromise}
 */

export function getIndexPage(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgIndexPage/getIndexPage",
    method: "post",
    data: params,
    showLoading: false
  });
}

/**
 * 获取机构商品列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listOrgCourseGoods(params) {
  return request({
    url: "/teachingPlatformService/api/app/course/listOrgCourseGoods",
    method: "post",
    data: params,
    showLoading: false
  });
}

/**
 * 根据轮播图获取考试的相关参数
 * @param params
 * @returns {AxiosPromise}
 */
export function getAppTestingVOById(params) {
  return request({
    url: "/teachingPlatformService/api/app/testing/getAppTestingVOById",
    method: "post",
    data: params
  });
}

/**
 * 是否为排除用户
 * @param params
 * @returns {AxiosPromise}
 */
export function withoutApproval(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/withoutApproval",
    method: "post",
    data: params
  });
}

/**
 * 上报消息-获得新券包弹窗
 * @param params
 * @returns {AxiosPromise}
 */
export function reportedMessage(params) {
  return request({
    url: "/userService/api/user/coupon/reportedMessage",
    method: "post",
    data: params
  });
}

/**
 * 获取未读消息-是否获得新券包弹窗
 * @param params
 * @returns {AxiosPromise}
 */
export function hashNotRedMessage(params) {
  return request({
    url: "/userService/api/user/coupon/hashNotRedMessage",
    method: "post",
    data: params
  });
}

/**
 * 是否收到消息
 * @param params
 * @returns {AxiosPromise}
 */
export function getsureUserJoinMes(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/getsureUserJoinMes",
    method: "post",
    data: params
  });
}

/**
 * 确定收到消息
 * @param params
 * @returns {AxiosPromise}
 */
export function sureUserJoinMes(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/sureUserJoinMes",
    method: "post",
    data: params
  });
}
/**
 * 填写用户的备注名
 * @param params
 * @returns {AxiosPromise}
 */
export function modifyUserRemarkName(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/modifyUserRemarkName",
    method: "post",
    data: params
  });
}
